import { render, staticRenderFns } from "./FacebookPixelIntegration.vue?vue&type=template&id=9040c3e2&scoped=true&"
import script from "./FacebookPixelIntegration.vue?vue&type=script&lang=js&"
export * from "./FacebookPixelIntegration.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPixelIntegration.vue?vue&type=style&index=0&id=9040c3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9040c3e2",
  null
  
)

export default component.exports